<template>
    <div class="content">
      <div class="warn-banner"><strong>🚧 This page is a work in progress! 🚧</strong><p>More details will be added soon.</p></div>
      <h1>Speedrunning</h1>
      <h2>My Journey & Achievements</h2>
      <p>
        Between the ages of <strong>15 and 20</strong>, I played a lot of games competitively,
        securing <strong>first place in 23 different games</strong>.
        I dominated Marble Blast Ultra's online leaderboards, placed top 10 in Forza 2,
        and even built my own leaderboard for Marble It Up: Mayhem!.
      </p>

      <h2>Global #1 Rankings</h2>
      <p>Here are some of the games where I held <strong>first place in the world</strong> at some point:</p>
      <ul>
        <li><strong>Marble Blast Ultra (Online Leaderboards)</strong> – 1st place.</li>
        <li><strong>Hydro Thunder Hurricane</strong> – 1st place.</li>
        <li><strong>N+</strong> – 1st place.</li>
        <li><strong>Bomberman</strong> – 1st place.</li>
        <li><strong>Splosion Man</strong> – 1st place.</li>
        <li><strong>Monday Night Combat</strong> – 1st place.</li>
        <li><strong>Peggle</strong> – 1st place.</li>
        <li><strong>Voodoo Dice</strong> – 1st place.</li>
        <li><strong>Madballs Babo: Invasion</strong> – 1st place.</li>
        <li><strong>Geon</strong> – 1st place.</li>
      </ul>

      <h2>Notable Achievements</h2>
      <p>Beyond just leaderboard rankings, here are some cool speedrunning moments:</p>
      <ul>
        <li><strong>Marble Blast Ultra:</strong> First player to collect 1 million gems online.</li>
        <li><strong>Marble Blast Ultra:</strong> Discovered a glitch to play single-player maps in multiplayer.</li>
        <li><strong>Trials HD:</strong> Held #1 on the first level for a long time.</li>
        <li><strong>Forza 2:</strong> Top 10 on High Speed Ring tuning a Nissan GTR.</li>
        <li><strong>Controller Modding:</strong> I modified Xbox 360 controllers to optimize diagonal movement for Marble Blast Ultra.</li>
      </ul>

      <h2>How I Approached Speedrunning</h2>
      <p>
        My strategy was simple: whenever a new speedrunning game came out, I would dedicate about a month
        to fully mastering it, usually securing 1st place on most levels.
        I also shared a console with my brother, so we took turns competing.
      </p>

      <h2>Related Content</h2>
      <ul>
        <li><a href="/marble-blast-ultra">Marble Blast Ultra - Full Breakdown</a></li>
        <li><a href="/controller-modding">Custom Controller Modding for Speedrunning</a></li>
        <li><a href="https://marble.pittroche.co.uk/" target="_blank">Marble It Up: Mayhem Leaderboard</a></li>
      </ul>

      <h2>More To Come!</h2>
      <p>I'm working on adding more details about strategies, glitches, and my experiences in speedrunning communities.</p>
    </div>

</template>


